import { Button, DocumentCheckbox } from '@components/Generic'
import { cx } from '@/utils/cx'
import { observer } from 'mobx-react'
import { useContext, useState } from 'react'
import PrivacyPolicy from '../assets/privacy_policy.pdf'
import PrivacyPolicyDe from '../assets/privacy_policy_de.pdf'
import tink from '../assets/tink_logo.png'
import { StoreContext } from '@store/Root.store'
import { IkanoInfoGraph } from './ikano/icons/IkanoInfoGraph'
import { CheckedEvent } from '@/types/generic'
import { isAccountInformation } from '@/methods/tinkTransactionType'

export const MicropaymentInfoPage = observer(() => {
  const [consent, setConsent] = useState(false)

  const store = useContext(StoreContext)
  const { language } = store.TranslationsState
  const {
    klarnaPrivacyPolicyPage: policyPage,
    micropaymentInfoPage: trans,
    generalConditionsPage: generalConditionsTrans,
  } = store.TranslationsState.translationsNew

  const { isMobile } = store.AppState
  const { context } = store.ScenarioState

  // AIS sessions only ask for account access, so the 0,01 EUR transfer copy
  // would be wrong. Fall back to the micropayment copy until Crowdin delivers
  // the AIS keys for a language.
  const copy =
    isAccountInformation(context) && trans.accountInformation ? trans.accountInformation : trans

  const handleProceed = async () => {
    store.ScenarioState.nextPage()
  }

  const handleConsent = ({ checked: value }: CheckedEvent) => {
    setConsent(value)
  }

  return (
    <div className={cx('page-container', 'mobile-m-0', 'mobile-p-14-40')}>
      <div className="ikano__micropayment-info-graph">
        <IkanoInfoGraph />
      </div>

      {copy.content.split('\n').map((item, i) => (
        <div className="generic__micropayment-info-content" key={i}>
          {item}
        </div>
      ))}

      <div className="ikano__tink-info">
        <div className="ikano__center-liner">
          <img src={tink} alt="tink logo" />
        </div>
        {copy.tink}
      </div>

      <DocumentCheckbox
        inputName="terms-checkbox"
        description={policyPage.consent}
        externalUrl={language === 'de' ? PrivacyPolicyDe : PrivacyPolicy}
        handleDecision={handleConsent}
        value={consent}
        goToDocumentLabel={generalConditionsTrans.goToDocument}
      />

      <div className="layout__content-container-bottom-fixed">
        {!isMobile ? <div className="layout__content-container-bottom-left" /> : <div />}
        <Button onClick={() => handleProceed()} disabled={!consent}>
          <span className="generic__button-text">{trans.proceed}</span>
        </Button>
      </div>

      <div className="layout__mobile-spacer-for-content-container-bottom-fixed" />
    </div>
  )
})
